exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qr-code{padding-top:7%;max-width:80px;max-height:120px;margin:10px}", ""]);

// exports
